import React from 'react'
import { Link, useParams, useHistory } from 'react-router-dom'
import { Typography, Grid, Link as StyledLink } from '@material-ui/core/'
import { Step1, Step2, Step3, Step4, Step5 } from './steps'
import arrowBack from '../../assetss/img/arrowBack.svg'
import checkedStep from '../../assetss/img/checkedStep.svg'
import introIcon from '../../assetss/img/introIcon.svg'
import c from 'classnames'
import './index.scss'

const NewStory = () => {
  const { step } = useParams()
  const history = useHistory()

  const pages = {
    1: () => <Step1 />,
    2: () => <Step2 />,
    3: () => <Step3 />,
    4: () => <Step4 />,
    5: () => <Step5 />,
  }

  const content = pages[step] || pages[1]

  return (
    <Grid
      className={c('createStoryContainer', step === '3' && 'newBgStep', step === '5' && 'hashBack')}
    >
      <Grid container className='boxCreateStory' alignItems='center'>
        <Grid className='backNewStoryBox'>
          <Grid className={c('backNewStoryContainer', step !== '1' && 'backNewStoryContainerWidth')}>
            <div className='tabBox' onClick={() => history.push('/')}>
              <Link>
                <img className='arrowIcon' src={arrowBack} alt='arrowBack' />
              </Link>
              <Typography className='backText'>
                Back
              </Typography>
            </div>

            <StyledLink href='https://tellme-place.info/introduction' target='_blank' className='introNewStory'>
              <img className='introIcon' src={introIcon} alt='introIcon' />
              <span className='introTextNewStory'>Watch intro</span>
              <span className='introTextNewStoryMobile'>Intro</span>
            </StyledLink>
          </Grid>
        </Grid>

        {step !== '1' && (
          <Grid className='wrapperSteperNewStory'>
            <Grid className='stepperContainer'>
              <Typography className={c('stepNumber', step === '2' && 'activeStep')}>
                <span className='stepText'>Step</span> <span className='stepNumberMobile'>1</span> {+step > 2 && <img className='checkedIcon' src={checkedStep} alt='checkedStep' />}
              </Typography>
              <Typography className={c('stepNumber', step === '3' && 'activeStep')}>
                <span className='stepText'>Step</span> <span className='stepNumberMobile'>2</span> {+step > 3 && <img className='checkedIcon' src={checkedStep} alt='checkedStep' />}
              </Typography>
              <Typography className={c('stepNumber', step === '4' && 'activeStep')}>
                <span className='stepText'>Step</span> <span className='stepNumberMobile'>3</span> {+step > 4 && <img className='checkedIcon' src={checkedStep} alt='checkedStep' />}
              </Typography>
              <Typography className={c('stepNumber', step === '5' && 'activeStep')}>
                <span className='stepText'>Step</span> <span className='stepNumberMobile'>4</span>
              </Typography>
            </Grid>
          </Grid>
        )}
        {content()}
      </Grid>
    </Grid>
  )
}

export default NewStory
